import type { DocNode } from '@atlaskit/adf-schema';

type EditorPluginAIEvent = {
	adfResponse?: DocNode | DocNode['content'][number];
	type: 'complete' | 'stream' | 'error';
};

/**
 * Normalises an event into the shape used by actor.send().
 * Required in editor-plugin-ai and editor-plugin-ai-streaming-orchestrator
 * to ensure that the events are in the same shape as the actor.send() events
 * for backwards compatibility.
 *
 * This can be cleaned up with platform_editor_ai_migrate_from_xstate.
 */
export function normaliseAIExperienceEvent(event: EditorPluginAIEvent):
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			type: 'complete' | 'stream' | 'error';
			markdown: string;
			cacheKey: string;
			// eslint-disable-next-line @typescript-eslint/no-empty-object-type
			modelInput: {};
	  }
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			type: 'complete' | 'stream' | 'error';
			markdown: string;
	  }
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			type: 'complete' | 'stream' | 'error';
			cacheKey: string;
			// eslint-disable-next-line @typescript-eslint/no-empty-object-type
			modelInput: {};
	  } {
	switch (event.type) {
		case 'complete':
			return {
				markdown: '',
				cacheKey: '',
				modelInput: {},
				...event,
			};

		case 'stream':
			return {
				markdown: '',
				...event,
			};

		case 'error':
			return {
				cacheKey: '',
				modelInput: {},
				...event,
			};
	}
}
